module.exports = new __parcel__URL__("code-preview-dark.6f4d4989.svg").toString();